import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selectAll", "checkbox", "selectedCount"]

  connect() {
    this.updateSelectedCount()
  }

  selectAllChanged() {
    const isChecked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = isChecked
    })
    this.updateSelectedCount()
  }

  checkboxChanged() {
    const allChecked = this.checkboxTargets.every(cb => cb.checked)
    const anyChecked = this.checkboxTargets.some(cb => cb.checked)
    
    if (this.checkboxTargets.length > 0) {
      this.selectAllTarget.checked = allChecked
      this.selectAllTarget.indeterminate = anyChecked && !allChecked
    }
    this.updateSelectedCount()
  }

  updateSelectedCount() {
    const checkedCount = this.checkboxTargets.filter(cb => cb.checked).length
    this.selectedCountTarget.textContent = `已选择 ${checkedCount} 项`
  }
}